import styled from 'styled-components';

export const Wrapper = styled.div(({ theme: { color, size, borderRadius } }) => ({
  width: '100%',
  height: size.units(6),
  borderRadius: borderRadius.medium,

  background: `linear-gradient(to right, ${color.background.tertiary.default(0.05)} 50%, ${color.background.tertiary.default(0)} 100%)`,
}));
